<template>
  <div class="feedback-page">
    <a-card>
      <div class="feedback-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="feedback-title">问题反馈</div>
          <a-tabs v-model:activeKey="tabKey" style="margin-bottom: 16px;">
            <a-tab-pane key="todo" tab="待受理" />
            <a-tab-pane key="doing" tab="受理中" />
            <a-tab-pane key="done" tab="已完成" />
          </a-tabs>
          <a-table :columns="columns" :data-source="[]" :pagination="false" size="middle" style="margin-top: 8px;">
            <template #emptyText>
              <div style="text-align:center;padding:32px 0;">
                <a-empty description="暂无数据" />
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

const tabKey = ref('todo')

const columns = [
  { title: '反馈ID', dataIndex: 'id', key: 'id' },
  { title: '反馈用户账号', dataIndex: 'user', key: 'user' },
  { title: '反馈类型', dataIndex: 'type', key: 'type' },
  { title: '反馈内容', dataIndex: 'content', key: 'content' },
  { title: '联系方式', dataIndex: 'contact', key: 'contact' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]
</script>

<style lang="less" scoped>
.feedback-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
  .feedback-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #f8fafb;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .feedback-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 12px;
      }
    }
  }
}
</style> 